import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import PaymentIcon from '@mui/icons-material/Payment';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import SupportIcon from '@mui/icons-material/Support';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { add_product_to_stock, getByProdRef, getByProdCode,update_product_in_stock } from '../../../../services/stock_service';
//import { is_Immobilisable } from '../../../../services/immobilsation_service';
  import CancelIcon from '@mui/icons-material/Cancel';
  import AddIcon from '@mui/icons-material/Add';
  import EditIcon from '@mui/icons-material/Edit';
  const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

const columns = [
    { id: 'product_reference', label: "Code du référence", minWidth: 0 },
    { id: 'product_name', label: "Produit", minWidth: 0 },
    { id: 'product_category', label: "Famille d'achat", minWidth: 0 },
    { id: 'product_supplier', label: "Fournisseur", minWidth: 0 },
    { id: 'product_quantity', label: "Quantité", minWidth: 0 },
    { id: 'product_price', label: "Prix (MAD)", minWidth: 0 }
];

const Add_to_stock_modal = ({ suppliers, categories, open_addProduct_to_stock_modal, handleClose_addProduct_to_stock_modal, update_product_infos, verify_product_by_code_in_stock, verify_product_by_reference_in_stock }) => {

    const classes = useStyles();
    let user = JSON.parse(localStorage.getItem('user-info'));
    const user_id = user.id;

    const [errorText, setErrorText] = useState("");
    const [warningText, setwarningText] = useState("");
    const [original_product_code, setoriginal_product_code] = useState(null);
    const [original_product_reference, setoriginal_product_reference] = useState(null);

    const [title, settitle] = useState('');
    const [product_reference, setproduct_reference] = useState("");
    const [product_code, setProduct_code] = useState('');
    const [supplier, setSupplier] = useState("null");
    const [quantity, setquantity] = useState('');
    const [price, setprice] = useState('');
    const [description, setdescription] = useState('');
    const [category, setCategory] = useState('null');
    const [min_stock, setmin_stock] = useState(0);
    const [safety_stock, setsafety_stock] = useState(0);
    const [duree_amortissement, setDuree_amortissement] = useState('');
    const [methode_amortissement, setMethode_amortissement] = useState(true);
    const [isImmo, setIsImmo] = useState(null); // or false by default

    const [pics, setPics] = useState([]);
    const [pics_url, setPics_url] = useState([]);

    const [existing_products, setexisting_products] = useState(null);
    const [product_infos, setProduct_infos] = useState(null);

    const [waiting, setWaiting] = useState(false);

    // When update_product_infos is passed (from view_product_details), update the state immediately.
    useEffect(() => {
        if (update_product_infos) {
            const { product, id_products_by_supplier } = update_product_infos;
            const productData = product.products_by_supplier[id_products_by_supplier];

            settitle(product.product_name);
            setProduct_code(productData.product_code);
            setproduct_reference(productData.product_reference);
            setSupplier(productData.supplier);
            setquantity(productData.product_quantity);
            setprice(productData.product_price);
            setdescription(productData.product_description);
            setCategory(product.product_category);
            setmin_stock(product.min_stock || 0);
            setsafety_stock(product.safety_stock || 0);

           //  console.log("Modal received product details:", productData);
        }
    }, [update_product_infos]);

    //this data displayed if product exist
    useEffect(() => {
        if (existing_products && product_infos.length !== 0) {
            const product_info = product_infos[0];
            const  minstock=existing_products[0]?.min_stock || 0;    
            const safestock=existing_products[0]?.safety_stock || 0;
            settitle(product_info.product_name);
            setProduct_code(product_info.product_code);
            setproduct_reference(product_info.product_reference);

            setoriginal_product_reference(product_info.product_reference);
            setSupplier(product_info.supplier);
            setquantity(product_info.product_quantity);
            setprice(product_info.product_price);
            setdescription(product_info.product_description);
            setCategory(product_info.product_category);
            setmin_stock(minstock || 0);
            setsafety_stock(safestock || 0);
           //  console.log("Product info:", product_info,"hadi---",minstock);
        }
    }, [ product_infos]);


    async function on_product_reference_change(value) {
        setwarningText("");
        setexisting_products(null);
        setproduct_reference(value);
        let tmp_existing_prd = null;
        if (original_product_reference) {
            if (original_product_reference != value) tmp_existing_prd = await verify_product_by_reference_in_stock([value]);
        } else {
            tmp_existing_prd = await verify_product_by_reference_in_stock([value]);
        }
       //  console.log("existing prd", tmp_existing_prd);
        if (tmp_existing_prd && tmp_existing_prd.length != 0) setwarningText("Référence du produit existant !");
        setexisting_products(tmp_existing_prd);

        if (tmp_existing_prd && tmp_existing_prd.length != 0) {
            const prod_ref = tmp_existing_prd[0].product_reference;
            const test = await getByProdRef(prod_ref);
            setProduct_infos(test.data);
           //  console.log('test', test);
        }
    }

    async function on_product_code_change(value) {
        setwarningText("");
        setexisting_products(null);
        setProduct_code(value);
        setIsImmo(null); // Reset when changing product code
    
        let tmp_existing_prd = null;
    
        if (original_product_code) {
            if (original_product_code !== value) {
                tmp_existing_prd = await verify_product_by_code_in_stock([value]);
            }
        } else {
            tmp_existing_prd = await verify_product_by_code_in_stock([value]);
           //  console.log("tmp_existing_prd**", tmp_existing_prd);
           setexisting_products(tmp_existing_prd);
            const test = await getByProdCode(value); 
            setProduct_infos(test.data);
           //  console.log('test2', test);
            
        }
    
        if (tmp_existing_prd && tmp_existing_prd.length !== 0) {
            setwarningText("Code produit existant !");
        }
    
        //setexisting_products(tmp_existing_prd);
    
        // Call the is_Immobilisable API and update state
        // try {
        //     const res = await is_Immobilisable({ product_code: value });
        //     const isImmoValue = res.data?.product?.is_immobilizable ?? null;
        //     setIsImmo(isImmoValue);
        //    //  console.log("is_immobilisable:", isImmoValue);
        // } catch (error) {
        //     console.error("Error fetching is_immobilisable:", error);
        //     setIsImmo(null);
        // }
    }
    

    async function addProduct() {
       //  console.log(supplier);
        setErrorText("");
        if (title === '' || product_code === '' || price === '' || quantity === '' || category === "null") {
            setErrorText("Champs invalides !");
        } else {
            setWaiting(true);
            const formData = new FormData();
            formData.append("add_to_stock", 1);
            formData.append("product_reference", product_reference);
            formData.append("product_code", product_code);
            if (supplier != "null") formData.append("product_supplier", supplier);
            formData.append("product_category", category);
            formData.append("product_quantity", quantity);
            formData.append("product_name", title);
            formData.append("product_description", description);
            formData.append("performed_by", user_id);
            formData.append("product_price", price);
            formData.append("average_price", price);
            formData.append("added_from_offer_call", 0);
            formData.append("duree_amortissement", duree_amortissement);
            formData.append("methode_amortissement", methode_amortissement ? 1 : 0 );
            formData.append("min_stock", min_stock);
            formData.append("safety_stock", safety_stock);

           //  console.log(duree_amortissement, methode_amortissement);
            

            await add_product_to_stock(formData).then((response) => {
               //  console.log(response.data);
                handleClose_addProduct_to_stock_modal();
                setWaiting(false);
            }).catch((error) => {
               //  console.log(error.response);
                setWaiting(false);
            });
        }
    }

    // function get_category_name_by_id(id_category) {
    //     let tmp_name = "";
    //     for (let category of categories) {
    //         if (category.id_category == parseInt(id_category)) tmp_name = category.name;
    //     }
    //     return tmp_name;
    // }

    // function get_supplier_by_id(id) {
    //     let tmp_supplier = "";
    //     for (let supplier of suppliers) {
    //         if (supplier.id == id) { tmp_supplier = supplier.parentCompany; break; }
    //     }
    //     return tmp_supplier;
    // }

    // async function updateProduct_infos() {
    //    //  console.log(supplier);
    //     setErrorText("");
    //     if (title === '' || product_code === '' || price === '' || quantity === '' || category === "null") {
    //         setErrorText("Champs invalides !");
    //     } else {
    //         setWaiting(true);
    //         const formData = new FormData();
    //         formData.append("add_to_stock", 1);
    //         formData.append("product_reference", product_infos[0].product_reference);
    //         formData.append("product_code", product_code);
    //         formData.append("product_supplier", supplier == "null" ? null : supplier);
    //         formData.append("product_category", category);
    //         formData.append("product_name", title);
    //         formData.append("product_description", description);
    //         formData.append("performed_by", user_id);
    //         formData.append("average_price", price);
    //         formData.append("added_from_offer_call", 0);
    //         formData.append("product_quantity", Number(quantity));
    //         formData.append("product_price", Number(price));
    //         formData.append("min_stock", Number(min_stock));
    //         formData.append("safety_stock", Number(safety_stock) || 0);
    //         await update_product_in_stock(formData).then((response) => {
    //            //  console.log(response.data);
    //             handleClose_addProduct_to_stock_modal();
    //             setWaiting(false);
    //         }).catch((error) => {
    //            //  console.log(error.response);
    //             setWaiting(false);
    //         });
    //     }
    // }

    return (
        <Dialog fullWidth={true} maxWidth={'md'} open={open_addProduct_to_stock_modal} onClose={handleClose_addProduct_to_stock_modal} aria-labelledby="form-dialog-title" >
            <DialogTitle id="form-dialog-title">Ajouter votre Produit</DialogTitle>
            <DialogContent>
                <div className="add_product_modal_infos">
                    <div className="inputs_container">
                        <TextField variant='standard' label="Code de référence" className="input_form" value={product_reference}
                            InputProps={{ startAdornment: (<InputAdornment position="start"> <BookmarkIcon className="my_icon" /> </InputAdornment>) }} onBlur={(e) => on_product_reference_change(e.target.value)} onChange={(e) => setproduct_reference(e.target.value)} />
                        
                        <TextField variant='standard' label="Code de produit" className="input_form" value={product_code}
                            InputProps={{ startAdornment: (<InputAdornment position="start"> <BookmarkIcon className="my_icon" /> </InputAdornment>) }} onBlur={(e) => on_product_code_change(e.target.value)} onChange={(e) => setProduct_code(e.target.value)} />

                        <TextField variant='standard' label="Titre" style={{ flex: 1, margin: "0px 0px 20px 0px" }} value={title}
                            InputProps={{ startAdornment: (<InputAdornment position="start"> <BookmarkIcon className="my_icon" /> </InputAdornment>) }} onChange={(e) => settitle(e.target.value)} />
                    </div>
                    <div className="inputs_container">
                        <FormControl variant='standard' className="input_form">
                            <InputLabel id="demo-simple-select-helper-label">Maison mère -- Fournisseur</InputLabel>
                            <Select value={supplier} onChange={(e) => { setSupplier(e.target.value) }}>
                                <MenuItem value="null" disabled selected>
                                    Maison mère -- Fournisseur
                                </MenuItem>
                                {suppliers.map((val, index) => {
                                    return (<MenuItem key={"supplier-" + index} value={val.id}>{val.parentCompany + " -- " + val.fullName}</MenuItem>)
                                })}
                            </Select>
                        </FormControl>

                        <FormControl variant='standard' className="input_form">
                            <InputLabel id="demo-simple-select-helper-label">Famille d'achat</InputLabel>
                            <Select value={category} onChange={(e) => { setCategory(e.target.value) }}>
                                <MenuItem value="null" disabled selected>
                                    Famille d'achat
                                </MenuItem>
                                {categories.map((val, index) => {
                                    return (<MenuItem key={index} value={val.id_category}>{val.name}</MenuItem>)
                                })}
                            </Select>
                        </FormControl>

                        <TextField variant='standard' label="Prix (DH) " type="number" className="input_form" value={price}
                            InputProps={{ startAdornment: (<InputAdornment position="start"> <PaymentIcon className="my_icon" /> </InputAdornment>) }} onChange={(e) => setprice(e.target.value)} />
                    </div>

                    <div className="inputs_container" >
                        <TextField variant='standard' label="Quantité" type="number" className="input_form" value={quantity}
                            InputProps={{ startAdornment: (<InputAdornment position="start"> <ProductionQuantityLimitsIcon className="my_icon" /> </InputAdornment>) }} onChange={(e) => setquantity(e.target.value)} />

                        {  isImmo === 1 ? <>
                            <TextField variant="standard" label="Durée d'amortissement (années)" type="number" className="input_form" value={duree_amortissement}
                            InputProps={{ startAdornment: (<InputAdornment position="start"><ProductionQuantityLimitsIcon className="my_icon" /></InputAdornment>) }}
                            onChange={(e) => setDuree_amortissement(e.target.value)} />

                        <TextField
                        select
                        variant="standard"
                        label="Méthode d'amortissement"
                        className="input_form"
                        value={methode_amortissement ? 1 : 0}
                        onChange={(e) => setMethode_amortissement(parseInt(e.target.value) === 1)}
                        >
                        <MenuItem value={1}>Linéaire</MenuItem>
                        <MenuItem value={0}>Dégressif</MenuItem>
                        </TextField></>
                        : <></>}
                        <TextField variant='standard' label="Stock min" type="number" className="input_form" value={min_stock}
                            InputProps={{ startAdornment: (<InputAdornment position="start"> <RemoveCircleOutlineIcon className="my_icon" /> </InputAdornment>) }} onChange={(e) => setmin_stock(e.target.value)} />

                        <TextField variant='standard' label="Stock de réserve" type="number" className="input_form" value={safety_stock}
                            InputProps={{ startAdornment: (<InputAdornment position="start"> <SupportIcon className="my_icon" /> </InputAdornment>) }} onChange={(e) => setsafety_stock(e.target.value)} />
                    </div>
                    <div style={{ width: "100%", margin: "20px 0px 10px 0px" }} >
                        <TextField
                            id="outlined-multiline-flexible"
                            label="Description"
                            variant='outlined'
                            multiline
                            minRows={8}
                            value={description}
                            onChange={(e) => setdescription(e.target.value)}
                            style={{ width: "100%" }}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <div className='dialogBottom'>
                    <div>
                        {
                            errorText === ""
                                ? <></>
                                : <p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                                    {errorText}
                                </p>
                        }
                        {
                            warningText === ""
                                ? <></>
                                : <p className={warningText ? "col-md-10 warning" : "col-md-10 valid-champ"}>
                                    {warningText}
                                </p>
                        }
                    </div>
                    <div>
                        <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon className="my_icon" />} onClick={handleClose_addProduct_to_stock_modal} >
                            Annuler
                        </Button>
                        <>
                            {
                                existing_products && existing_products.length !== 0
                                    ? <Button variant="contained" className="submit_but valide_but" startIcon={<EditIcon className="my_icon" />} onClick={addProduct} >
                                        Modifier
                                    </Button>
                                    : <Button variant="contained" className="submit_but valide_but" startIcon={<AddIcon className="my_icon" />} onClick={addProduct} >
                                        Ajouter
                                    </Button>
                            }
                        </>
                    </div>
                </div>
            </DialogActions>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Dialog>
    );
}

export default Add_to_stock_modal;